module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-copyright element-without-heading",
    attrs: {
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Copyright © 2011 by Denise Grover Swank")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Cover art and design by Rebecca Curtis, CreateSpace, 2013")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("updated 2016")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Copy Editing by Carolina Valdez-Miller")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("All rights reserved.")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width copyright-content"
  }, [_vm._v("This book is a work of fiction. References to real people, events, establishments, organizations, or locations are intended only to provide a sense of authenticity, and are used fictitiously. All other characters, and all incidents and dialogue, are drawn from the author’s imagination and are not to be construed as real.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("ISBN: 978-1-939996-02-2")]), _vm._v(" "), _c('p', {
    staticClass: "created-with-vellum"
  }, [_c('a', {
    attrs: {
      "href": "http://tryvellum.com/created",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "created-with-vellum-image-decorator"
  }, [_c('span', {
    staticClass: "created-with-vellum-image-size-container"
  }, [_c('img', {
    staticClass: "created-with-vellum-image",
    attrs: {
      "alt": "Created with Vellum",
      "src": "images/vellum-created.png"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "created-with-vellum-text"
  }, [_vm._v("Created with Vellum")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 63
// module chunks = 0